import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_coffee_tea: FaireCategoryEntity = {
  token: "catalog_cat_coffee-tea",
  type: "category",
  name: "Coffee & tea",
  count: 6,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
